import { FC } from "react";

import { DISTANCE_DROPDOWN_ID } from "../const";
import classes from "./dropdown.scss";

interface IDropdownProps {
  options: {
    value: string;
    label: string;
  }[];
  onChange: (val: string) => void;
  value: string;
}

const Dropdown: FC<IDropdownProps> = ({ options, onChange, value }) => {
  return (
    <ul className={classes.root} id={DISTANCE_DROPDOWN_ID}>
      {options?.map((option) => {
        return (
          <li key={option.value} className={classes.option}>
            <button
              type="button"
              onClick={() => {
                onChange(option.value);
              }}
              data-t2={option.value}
              data-t1="distance_dropdown_button"
              disabled={value === option.value}
            >
              {option.label}
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default Dropdown;
